<template>
  <c-view>
    <c-page>
      <div class="text-color white text-center verify-container" :class="[isMiniProgramModel? 'verify-container--miniprogram': '']">
        <div class="navbar-panel">
          安全验证
        </div>
        <div class="mt-30 middle-text">
          验证短信已发送至
        </div>
        <div class="mt-20 telephone">
          {{ formItem.telephoneNum | secretPhoneNum}}
        </div>
        <div class="codeInput">
          <div class="code"
               v-for="(item, index) in showVerifyCodes"
               :key="index">
            {{ item }}
          </div>
        </div>
        <div class="mt-30 info">
        </div>
      </div>
    </c-page>
    <c-keyboard @key-press="pushCode"
                @key-del="deleteCode"></c-keyboard>
  </c-view>
</template>

<script>
import AgentRegisterModel from '../../../model/agent-register-user/index'
import { mixinsDevice } from '../../../mixins'
import CKeyboard from '../../temp'
export default {
  name: 'Activation',
  mixins: [mixinsDevice],
  data () {
    return {
      registerModel: new AgentRegisterModel(),
      formItem: {
        telephoneNum: null,
        codeNum: null,
        flowId: null
      },
      verifyCodes: [],
      sendSuccess: false
    }
  },
  components: { CKeyboard },
  mounted () {
    let phone = this.$route.query.phone
    this.formItem.flowId = this.$route.query.flowId
    if (phone && (/^((1)+\d{10})$/.test(phone))) {
      this.formItem.telephoneNum = phone
    } else {
      this.$route.push({ path: '/agent-register' })
    }
  },
  methods: {
    /**
     * 把输入的内容输入到数组
     * @param value
     */
    pushCode (value) {
      if (this.verifyCodes.length === 6) return
      this.verifyCodes.push(value)
    },
    /**
     * 删除输入的内容
     */
    deleteCode () {
      if (this.verifyCodes.length === 0) return
      this.verifyCodes.pop()
    },
    /**
     * 提交激活
     */
    submitSignupProcess () {
      let loadingInstance = this.$wejs.loading('数据提交中')
      this.registerModel.verifyCode({ account: this.formItem.telephoneNum, verifycode: this.formItem.codeNum, flowId: this.formItem.flowId }).then(json => {
        let status = json.data
        loadingInstance.hide()
        if (status === '-1') {
          this.$wejs.alert('验证码输入有误，请重试！')
        } else if (status === '1') {
          this.$wejs.alert('恭喜您，已经成功注册生意专家', () => {
            if (this.isMiniProgramModel) {
              // eslint-disable-next-line no-undef
              wx.miniProgram.navigateBack()
            } else {
              window.location.href = 'http://www.i200.cn/mobile/download.aspx?from=regmobileweb'
            }
          })
        }
      }).catch(_ => {
        loadingInstance.hide()
        this.$wejs.alert('验证出错')
      })
    }
  },
  computed: {
    showVerifyCodes () {
      let code = Array(6).fill(null)
      this.verifyCodes.forEach((item, index) => {
        code[index] = item
      })
      return code
    }
  },
  watch: {
    verifyCodes (val) {
      this.formItem.codeNum = val.join('')
      if (this.formItem.codeNum && this.formItem.codeNum.length === 6) {
        this.submitSignupProcess()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>



// WEBPACK FOOTER //
// index.vue?112115b5